import React, { useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import ClipLoader from "react-spinners/ClipLoader";
import OtpPin from "../OtpPin";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../constants/api";
import useAuthAxios from "../../utils/baseAxios";
import { errorMessage } from "../../utils/errorMessage";
import { useUser } from "../../context/user-context";

const AddOtp = ({
  setOpenAddOtp,
  setOpenSuccess,
}: {
  setOpenAddOtp: (value: boolean) => void;
  setOpenSuccess: (value: boolean) => void;
}) => {
  const queryClient = useQueryClient();
  const { refetch } = useUser();
  const [otp, setOtp] = useState("");
  const handleChange = (otp: string) => {
    setOtp(otp);
  };

  const axiosInstance = useAuthAxios();
  const handleVerify = async (data: any) => {
    const response = await axiosInstance.put(API.verifyPhoneOtp, data);
    return response.data;
  };
  const completeVerify = useMutation({
    mutationFn: handleVerify,
    onSuccess: (r) => {
      toast.success(r.message);
      setTimeout(() => {
        setOpenSuccess(true);
        setOpenAddOtp(false);
        queryClient.invalidateQueries({ queryKey: ["userDetails"] });
        refetch();
      }, 1000);
    },
    onError: (error: any) => {
      toast.error(
        errorMessage((error?.data as any)?.message || String(error?.data))
      );
    },
  });
  const verifyPhone = () => {
    const data = {
      otp: otp,
    };
    completeVerify.mutate(data);
  };
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenAddOtp(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-200 font-sora font-semibold text-[17px]">
            Verification
          </h4>
        </div>
        <div className="w-full mt-14">
          <h4 className="text-gray-900 text-center dark:text-gray-100 font-sora mb-4 font-semibold text-[24px]">
            Enter OTP Sent to your whatsapp
          </h4>
          <OtpPin otp={otp} input={6} setOtp={setOtp} />
          <button
            disabled={otp.length < 6}
            // onClick={() => {
            //   const data = {
            //     amount: Number(amount),
            //     phone: phone,
            //     network: network,
            //     pin: otp,
            //   };
            //   completeBuy.mutate(data);
            // }}
            onClick={verifyPhone}
            className={`mt-28 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl ${
              otp.length < 6 ? "opacity-50" : ""
            }`}
          >
            {completeVerify.isPending ? (
              <ClipLoader color="#FFFFFF" size={30} />
            ) : (
              "Verify"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddOtp;
